import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Tenant } from '../types';
import { STORAGE_KEYS } from '../utils/constants';
import storage from '../utils/storage';

interface TenantState {
  tenants: Tenant[];
  selectedTenantId: string;

  setTenants: (tenants: Tenant[]) => void;
  setSelectedTenantId: (id: string) => void;
  getTenantId: () => string;
  getSelectedTenant: () => Tenant | null;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set, get) => ({
      tenants: [],
      selectedTenantId: '',

      setTenants: (tenants: Tenant[]) => set({ tenants }),

      setSelectedTenantId: (id: string) => {
        storage.session.set(STORAGE_KEYS.TENANT_VALUE, id);
        set({ selectedTenantId: id });
      },

      getTenantId: () => {
        const id = storage.session.get<string>(STORAGE_KEYS.TENANT_VALUE);
        return id ?? get().selectedTenantId;
      },

      getSelectedTenant: () => {
        const { tenants, selectedTenantId } = get();
        return tenants.find((t) => t.id === selectedTenantId) ?? null;
      },
    }),
    {
      name: 'tenant-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

